import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AOS from "aos";
import { ProfileManger } from "../apis/profile/profile";
import { isLogin } from "../assets/js/utils";
import { AppContext } from "../components/AppContext/AppContext";


const useHideMnueByClickToWindow = (isExpanded, setIsExpanded) => {

    const location = useLocation().pathname;

    // ** Function to handle window resize
    const hendlResize = () => {

        if (window.innerWidth <= 1024) {

            setIsExpanded(false);

        } else {

            setIsExpanded(true);

        }
    }

    const handelHideMnue = () => {

        if (isExpanded) {

            setIsExpanded(false);

        }

    }

    useEffect(() => {
        // Create a new link element to represent the favicon
        const headIcon = document.createElement('link');

        // Select all existing link elements in the head with rel="icon"
        const removeOldestLogo = document.querySelectorAll('head link[rel="icon"]');

        // Remove all existing favicon link elements
        removeOldestLogo.forEach((item) => item.remove());

        // Set the rel and href attributes of the newly created link element
        headIcon.setAttribute('rel', 'icon');
        headIcon.setAttribute('href', require('./logo.png'));

        // Append the new link element to the head of the document
        document.head.appendChild(headIcon);

    }, [location]);

    useEffect(() => {

        window.addEventListener('resize', hendlResize);

        hendlResize();

        // Clean Up
        return () => window.removeEventListener('resize', hendlResize);

    }, [location]);

    useEffect(() => {

        if (window.innerWidth < 1025) {

            window.addEventListener('click', handelHideMnue);

        }

        // Clean Up
        return () => window.removeEventListener('click', handelHideMnue);
    }, [isExpanded]);

}

const useAppControlar = () => {

    const [isExpanded, setIsExpanded] = useState(false);

    const location = useLocation().pathname;

    const arrOfNotAvaliableHeader = ['/login', '/create-wallet'];

    const profileUtailty = new ProfileManger();

    const navigate = useNavigate();

    const { setIsLoading, user, setUser } = useContext(AppContext);

    const login = isLogin();

    // Hide Mnue When user Click On Window
    useHideMnueByClickToWindow(isExpanded, setIsExpanded);

    const [isRenderLayouts, setIsRenderLayouts] = useState(true);


    useEffect(() => {

        // To Control Toggle Show Header
        arrOfNotAvaliableHeader.includes(location) ? setIsRenderLayouts(false) : setIsRenderLayouts(true);

        // Clean Up
        return () => { };

    }, [location]);

    useEffect(() => {

        if (user?.status_phone !== 'COMPLETE' || user?.status_email !== 'COMPLETE') {

            if (location !== '/add-auction') {

                return navigate('/profile');

            }

        }

        return () => { };

    }, [location]);

    useEffect(() => {

        AOS.init({ duration: 1000 });

        AOS.refresh();

        // Clean Up
        return () => { };

    }, []);

    useEffect(() => {

        if (login) {

            setIsLoading(true);

            profileUtailty.userInfo(setUser).finally(_ => setIsLoading(false));

        }

    }, [login]);

    return { isRenderLayouts, isExpanded, setIsExpanded, setIsRenderLayouts };
}

const useUpdateImageProgress = (imagesUpload, setImagesUpload, activeIndex, setActiveIndex) => {

    useEffect(() => {
        if (imagesUpload.length === 0) {
            return; // No uploaded images, so exit the effect
        }

        const interval = setInterval(() => {

            setImagesUpload((prevState) => {

                const updatedImages = [...prevState];

                const activeImage = updatedImages.filter(image => image.progress !== 100)[0];

                if (activeImage?.progress < 100) {

                    activeImage.progress += 10;

                    if (activeImage.progress >= 100) {

                        setActiveIndex((prevIndex) => prevIndex + 1);

                        activeImage.status = 'active';

                    }

                } else if (activeImage?.progress === 100) {

                    setActiveIndex((prevIndex) => prevIndex + 1);

                }

                return updatedImages;

            });
        }, 400); // Updated interval to 400 milliseconds

        // loop for images to check if the intervel end or not
        const isComplated = imagesUpload.every(image => image.progress === 100);

        if (isComplated) {

            return clearInterval(interval);

        }

        return () => {

            clearInterval(interval);

        };
    }, [imagesUpload, activeIndex]);
}


export default function useCustomEffect() {
    return { useAppControlar, useUpdateImageProgress }
}
